import Selectybox from '../selectybox-1.0-source';

if ( Selectybox ) {
  window.Selectybox = Selectybox;
}
